/** Inner scroll container for Connections (not window). Discover infinite load must use this root. */
export const CONNECTIONS_SCROLL_AREA_ID = "connections-scroll-area";
